<template>
  <ProjectAdList :project="project"/>
</template>

<script>
import ProjectAdList from '../../../../components/Relations/ProjectAds/Panels/List'

export default {
  components: {ProjectAdList},

  model: {
    prop: 'project'
  },

  props: {
    project: {
      required: true,
      type: Object
    }
  }
}
</script>
